import { render, staticRenderFns } from "./linkMini.vue?vue&type=template&id=7202db33&scoped=true&"
import script from "./linkMini.vue?vue&type=script&lang=js&"
export * from "./linkMini.vue?vue&type=script&lang=js&"
import style0 from "./linkMini.vue?vue&type=style&index=0&id=7202db33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7202db33",
  null
  
)

export default component.exports